import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { ArrowLeft, Calendar } from "lucide-react";

export function Permissions() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Form State
  const [formData, setFormData] = useState({
    dipendente: "",
    email: "",
    richiesta: "Ferie",
    data_inizio: "",
    data_fine: "",
    dalle_ore: "",
    alle_ore: "",
    note: "",
    consenso: false
  });
  
  const [submitStatus, setSubmitStatus] = useState<{success: boolean; message: string} | null>(null);

  useEffect(() => {
    // BYPASS AUTH FOR LOCAL PREVIEW
    setIsAuthenticated(true);
    setLoading(false);

    /*
    const checkAuth = async () => {
      try {
        const response = await fetch("/api/check_auth.php");
        const data = await response.json();
        
        if (data.authenticated) {
          setIsAuthenticated(true);
        } else {
          navigate("/login");
        }
      } catch (err) {
        console.error(err);
        // navigate("/login");
        setIsAuthenticated(true); // Force true for preview
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
    */
  }, [navigate]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData(prev => ({
      ...prev,
      consenso: e.target.checked
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitStatus(null);

    if (!formData.consenso) {
      setSubmitStatus({ success: false, message: "È necessario accettare il consenso privacy." });
      return;
    }

    try {
      const response = await fetch("/api/submit_request.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...formData,
          consenso: formData.consenso ? "Accettato" : "Non Accettato"
        }),
      });
      
      const result = await response.json();
      
      if (result.success) {
        setSubmitStatus({ success: true, message: "Richiesta inviata con successo!" });
        // Reset form optionally
        setFormData({
            dipendente: "",
            email: "",
            richiesta: "Ferie",
            data_inizio: "",
            data_fine: "",
            dalle_ore: "",
            alle_ore: "",
            note: "",
            consenso: false
        });
      } else {
        setSubmitStatus({ success: false, message: result.message || "Errore durante l'invio." });
      }
    } catch (err) {
      console.error(err);
      setSubmitStatus({ success: false, message: "Errore di connessione al server." });
    }
  };

  if (loading) return <div className="text-center py-20 text-brand-primary">Caricamento...</div>;

  if (!isAuthenticated) return null;

  return (
    <div className="container mx-auto px-4 py-12 min-h-[70vh]">
      <div className="mb-8">
        <Link to="/area-riservata" className="inline-flex items-center text-brand-primary hover:underline mb-4">
          <ArrowLeft className="w-4 h-4 mr-2" /> Torna alla Dashboard
        </Link>
        <h1 className="text-3xl font-bold text-[#004080] uppercase tracking-wider">Richiesta Permessi / Ferie</h1>
        <p className="text-gray-600 mt-2">Compila il modulo per inviare una richiesta.</p>
      </div>

      <div className="bg-white rounded-lg shadow-md border border-gray-200 p-8 max-w-2xl mx-auto">
        {submitStatus && (
          <div className={`mb-6 p-4 rounded ${submitStatus.success ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-700'}`}>
            {submitStatus.message}
          </div>
        )}

        <form className="space-y-6" onSubmit={handleSubmit}>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="md:col-span-2">
              <label className="block text-sm font-medium text-gray-700 mb-1">Nome e Cognome Dipendente</label>
              <input 
                type="text" 
                name="dipendente" 
                value={formData.dipendente} 
                onChange={handleChange} 
                required 
                className="w-full border-gray-300 rounded-md shadow-sm focus:border-brand-primary focus:ring focus:ring-brand-primary focus:ring-opacity-50 p-2 border" 
                placeholder="Mario Rossi" 
              />
            </div>
            
            <div className="md:col-span-2">
              <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
              <input 
                type="email" 
                name="email" 
                value={formData.email} 
                onChange={handleChange} 
                className="w-full border-gray-300 rounded-md shadow-sm focus:border-brand-primary focus:ring focus:ring-brand-primary focus:ring-opacity-50 p-2 border" 
                placeholder="mario.rossi@esempio.it" 
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Tipo Richiesta</label>
              <select 
                name="richiesta" 
                value={formData.richiesta} 
                onChange={handleChange} 
                className="w-full border-gray-300 rounded-md shadow-sm focus:border-brand-primary focus:ring focus:ring-brand-primary focus:ring-opacity-50 p-2 border"
              >
                <option value="Ferie">Ferie</option>
                <option value="Permesso Retribuito">Permesso Retribuito</option>
                <option value="Malattia">Malattia</option>
                <option value="Altro">Altro</option>
              </select>
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Data Inizio</label>
              <div className="relative">
                <input 
                  type="date" 
                  name="data_inizio" 
                  value={formData.data_inizio} 
                  onChange={handleChange} 
                  required 
                  className="w-full border-gray-300 rounded-md shadow-sm focus:border-brand-primary focus:ring focus:ring-brand-primary focus:ring-opacity-50 p-2 border" 
                />
                <Calendar className="absolute right-3 top-2.5 h-4 w-4 text-gray-400 pointer-events-none" />
              </div>
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Data Fine</label>
              <div className="relative">
                <input 
                  type="date" 
                  name="data_fine" 
                  value={formData.data_fine} 
                  onChange={handleChange} 
                  required 
                  className="w-full border-gray-300 rounded-md shadow-sm focus:border-brand-primary focus:ring focus:ring-brand-primary focus:ring-opacity-50 p-2 border" 
                />
                <Calendar className="absolute right-3 top-2.5 h-4 w-4 text-gray-400 pointer-events-none" />
              </div>
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Dalle ore</label>
              <input 
                type="time" 
                name="dalle_ore" 
                value={formData.dalle_ore} 
                onChange={handleChange} 
                className="w-full border-gray-300 rounded-md shadow-sm focus:border-brand-primary focus:ring focus:ring-brand-primary focus:ring-opacity-50 p-2 border" 
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Alle ore</label>
              <input 
                type="time" 
                name="alle_ore" 
                value={formData.alle_ore} 
                onChange={handleChange} 
                className="w-full border-gray-300 rounded-md shadow-sm focus:border-brand-primary focus:ring focus:ring-brand-primary focus:ring-opacity-50 p-2 border" 
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Note Aggiuntive</label>
            <textarea 
              name="note" 
              rows={4} 
              value={formData.note} 
              onChange={handleChange} 
              className="w-full border-gray-300 rounded-md shadow-sm focus:border-brand-primary focus:ring focus:ring-brand-primary focus:ring-opacity-50 p-2 border" 
              placeholder="Inserisci eventuali dettagli..."
            ></textarea>
          </div>

          <div className="flex items-center gap-2">
            <input 
              type="checkbox" 
              id="consenso" 
              name="consenso" 
              checked={formData.consenso} 
              onChange={handleCheckboxChange} 
              className="rounded text-brand-primary focus:ring-brand-primary" 
            />
            <label htmlFor="consenso" className="text-sm text-gray-600">
              Acconsento al trattamento dei dati personali per la gestione della richiesta.
            </label>
          </div>

          <div className="flex justify-end gap-4 pt-4 border-t border-gray-100">
            <Button type="button" variant="outline" onClick={() => navigate("/area-riservata")}>Annulla</Button>
            <Button type="submit" className="bg-[#004080] hover:bg-[#003366] text-white">Invia Richiesta</Button>
          </div>
        </form>
      </div>
    </div>
  );
}
